import { TimeEntryType } from '/@/modules/timeentry/enums/TimeEntryType';
import { CEInvestmentTimeEntryMeta } from '/@/modules/timeentry/models/meta/CEInvestmentTimeEntryMeta';
import { PTOTimeEntryMeta } from '/@/modules/timeentry/models/meta/PTOTimeEntryMeta';
import { NonWorkRelatedTimeEntryMeta } from '/@/modules/timeentry/models/meta/NonWorkRelatedTimeEntryMeta';
import { EstateWorkTimeEntryMeta } from '/@/modules/timeentry/models/meta/EstateWorkTimeEntryMeta';
import { TimeEntryTypeKey } from '@/modules/timeentry/constants/TimeEntryTypeKey';

export type TimeEntryMetaType =
  | EstateWorkTimeEntryMeta
  | CEInvestmentTimeEntryMeta
  | PTOTimeEntryMeta
  | NonWorkRelatedTimeEntryMeta;

export class TimeEntryMeta {
  static factory(type: TimeEntryTypeKey | undefined, model = {}): TimeEntryMetaType | null {
    switch (type) {
      case TimeEntryType.ESTATE_WORK.key:
        return new EstateWorkTimeEntryMeta(model);
      case TimeEntryType.CEI.key:
        return new CEInvestmentTimeEntryMeta();
      case TimeEntryType.PTO.key:
        return new PTOTimeEntryMeta();
      case TimeEntryType.NON_WORK_RELATED.key:
        return new NonWorkRelatedTimeEntryMeta();
      default:
        return null;
    }
  }
}
